export const checkIsHTMLStringUsingRegex = (str: string): boolean => {
	const htmlRegex = /<\/?[a-z][\s\S]*>/i; // Matches opening or closing HTML tags
	return htmlRegex.test(str);
};

export const checkIsHTMLStringUsingDOMParser = (str: string): boolean => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(str, 'text/html');

	// If the parsed document contains any elements, it's HTML
	return Array.from(doc.body.childNodes).some(node => node.nodeType === 1); // Node.ELEMENT_NODE === 1
};

